import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@openfin/ui-library';
import { GroupingNamesMap, GroupingType } from '../../utils/Grouping';
import { TabGroup } from '../TabGroup/TabGroup';

interface Props {
  groupBy: GroupingType;
  onSortingChange: (value: string) => void;
  onClearAll: () => void;
}

export const SortingPanel = ({ groupBy, onSortingChange, onClearAll }: Props): JSX.Element => (
  <Container>
    <TabGroup
      options={Object.values(GroupingType)}
      labels={Object.values(GroupingNamesMap)}
      activeOption={groupBy}
      onChange={onSortingChange}
    />
    <ClearAll onClick={onClearAll}>Clear All</ClearAll>
  </Container>
);

const Container = styled(Box)`
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.px.large};
`;

const ClearAll = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.palette.textDefault};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.large};
  user-select: none;
`;
